import * as url from 'url';

import { environment } from '../../environments/environment';

// const PDF_VERSION_SUFFIX = (new Date()).toISOString().replace(/[^0-9]/g, '');

export class Constants {
  static readonly SessionKeyCurrentLanguage = 'Language';
  static readonly SessionKeyAuthorizationData = 'AuthData';
  static readonly SessionKeyUserFullName = 'UserFullName';
  static readonly SessionKeyProductSubClass = 'ProductSubClass';

  static readonly LanguageCodeEnglish: string = 'en';
  static readonly LanguageCodeFrench: string = 'fr';
  static readonly DefaultLanguageCode = Constants.LanguageCodeEnglish;

  static readonly LocaleEnglishCanada: string = 'en-CA';
  static readonly LocaleFrenchCanada: string = 'fr-CA';

  // ========================
  // == NOT IN USE anymore ==
  //
  // static readonly ItsrContactInfoApiLanguageEnglish = 'English';
  // static readonly ItsrContactInfoApiLanguageFrench = 'Français';
  // ========================

  static readonly GenericErrorMessageEnglish = 'An error has occurred.';
  static readonly GenericErrorMessageFrench = 'Une erreur s\'est produite.';

  static readonly CmsApiBaseUrl = url.format({
    protocol: environment.cmsApiProtocol,
    hostname: environment.cmsApiHostName,
    port: environment.cmsApiPort,
    pathname: environment.cmsApiBasePath
  });

  static readonly ItsrApiBaseUrl = url.format({
    protocol: environment.itsrApiProtocol,
    hostname: environment.itsrApiHostName,
    port: environment.itsrApiPort,
    pathname: environment.itsrApiBasePath
  });

  // IMPORTANT all paths MUST end with a path separator
  static readonly BasePathAssets = '/assets/';
  static readonly BasePathImages = url.resolve(Constants.BasePathAssets, 'img/');
  static readonly BasePathPdf = url.resolve(Constants.BasePathAssets, 'pdf/');
  static readonly BasePathTermsAndConditionsPdf = url.resolve(Constants.BasePathPdf, 'terms/');
  static readonly BasePathTermsAndConditionsMobilePdf = url.resolve(Constants.BasePathPdf, 'terms/mobile/');
  static readonly BasePathBenefitGuidePdf = url.resolve(Constants.BasePathPdf, 'benefits/');
  static readonly BasePathBenefitGuideMobilePdf = url.resolve(Constants.BasePathPdf, 'benefits/mobile/');

  static readonly PdfSource: string[][] = [
    /*  0 */ [
      url.resolve(Constants.BasePathTermsAndConditionsPdf, 'Conditions - Total Plan.pdf'),
      url.resolve(Constants.BasePathTermsAndConditionsMobilePdf, 'Conditions - Total Plan.pdf')
    ],
    /*  1 */ [
      url.resolve(Constants.BasePathTermsAndConditionsPdf, 'Conditions - Systems Plan.pdf'),
      url.resolve(Constants.BasePathTermsAndConditionsMobilePdf, 'Conditions - Systems Plan.pdf')
    ],
    /*  2 */ [
      url.resolve(Constants.BasePathTermsAndConditionsPdf, 'Conditions - Appliances Plan.pdf'),
      url.resolve(Constants.BasePathTermsAndConditionsMobilePdf, 'Conditions - Appliances Plan.pdf')
    ],

    /*  3 */ [
      url.resolve(Constants.BasePathTermsAndConditionsPdf, 'Conditions - Plan Complet.pdf'),
      url.resolve(Constants.BasePathTermsAndConditionsMobilePdf, 'Conditions - Plan Complet.pdf')
    ],
    /*  4 */ [
      url.resolve(Constants.BasePathTermsAndConditionsPdf, 'Conditions - Plan Systemes.pdf'),
      url.resolve(Constants.BasePathTermsAndConditionsMobilePdf, 'Conditions - Plan Systemes.pdf')
    ],
    /*  5 */ [
      url.resolve(Constants.BasePathTermsAndConditionsPdf, 'Conditions - Appareils Menagers.pdf'),
      url.resolve(Constants.BasePathTermsAndConditionsMobilePdf, 'Conditions - Appareils Menagers.pdf')
    ],

    /*  6 */ [
      url.resolve(Constants.BasePathBenefitGuidePdf, 'Benefit Guide - Total Plan.pdf'),
      url.resolve(Constants.BasePathBenefitGuideMobilePdf, 'Benefit Guide - Total Plan.pdf')
    ],
    /*  7 */ [
      url.resolve(Constants.BasePathBenefitGuidePdf, 'Benefit Guide - Systems Plan.pdf'),
      url.resolve(Constants.BasePathBenefitGuideMobilePdf, 'Benefit Guide - Systems Plan.pdf')
    ],
    /*  8 */ [
      url.resolve(Constants.BasePathBenefitGuidePdf, 'Benefit Guide - Appliances Plan.pdf'),
      url.resolve(Constants.BasePathBenefitGuideMobilePdf, 'Benefit Guide - Appliances Plan.pdf')
    ],

    /*  9 */ [
      url.resolve(Constants.BasePathBenefitGuidePdf, 'Avantages - Plan Complet.pdf'),
      url.resolve(Constants.BasePathBenefitGuideMobilePdf, 'Avantages - Plan Complet.pdf')
    ],
    /* 10 */ [
      url.resolve(Constants.BasePathBenefitGuidePdf, 'Avantages - Plan Systemes.pdf'),
      url.resolve(Constants.BasePathBenefitGuideMobilePdf, 'Avantages - Plan Systemes.pdf')
    ],
    /* 11 */ [
      url.resolve(Constants.BasePathBenefitGuidePdf, 'Avantages - Appareils Menagers.pdf'),
      url.resolve(Constants.BasePathBenefitGuideMobilePdf, 'Avantages - Appareils Menagers.pdf')
    ]
  // ].map((item) => item.map((pdfUrl) => `${pdfUrl}?v=${PDF_VERSION_SUFFIX}`));
  ];

  static readonly PdfSourceIndexMap = {
    conditions: {
      total:      { [Constants.LanguageCodeEnglish]: 0, [Constants.LanguageCodeFrench]: 3 },
      systems:    { [Constants.LanguageCodeEnglish]: 1, [Constants.LanguageCodeFrench]: 4 },
      appliances: { [Constants.LanguageCodeEnglish]: 2, [Constants.LanguageCodeFrench]: 5 },

      complet:     { [Constants.LanguageCodeEnglish]: 0, [Constants.LanguageCodeFrench]: 3 },
      systemes:    { [Constants.LanguageCodeEnglish]: 1, [Constants.LanguageCodeFrench]: 4 },
      appareilsem: { [Constants.LanguageCodeEnglish]: 2, [Constants.LanguageCodeFrench]: 5 }
    },
    benefits: {
      total:      { [Constants.LanguageCodeEnglish]: 6, [Constants.LanguageCodeFrench]:  9 },
      systems:    { [Constants.LanguageCodeEnglish]: 7, [Constants.LanguageCodeFrench]: 10 },
      appliances: { [Constants.LanguageCodeEnglish]: 8, [Constants.LanguageCodeFrench]: 11 }
    },
    avantages: {
      complet:     { [Constants.LanguageCodeEnglish]: 6, [Constants.LanguageCodeFrench]:  9 },
      systemes:    { [Constants.LanguageCodeEnglish]: 7, [Constants.LanguageCodeFrench]: 10 },
      appareilsem: { [Constants.LanguageCodeEnglish]: 8, [Constants.LanguageCodeFrench]: 11 }
    },
    indexOf(path: string[]): number {
      try {
        const index = path.reduce((obj, key) => obj[key], this);
        return typeof index === 'number' ? index : -1;
      } catch (e) {
        return -1;
      }
    }
  };

  static readonly RegEx = {
    get NonWhitespaceValue() { return '^[^\\s]+$'; },
    get SubscriptionNumber() { return '^[a-zA-Z]{2}[0-9]{9}$'; },
    get FirstName() { return '^[a-z A-Z]+$'; },
    get LastName() { return '^[a-z A-Z]+$'; },
    get PhoneNumber() { return '^[0-9]{3}([ -\\.]?)[0-9]{3}([ -\\.]?)[0-9]{4}$'; },
    get Email() { return '^[a-zA-Z0-9_\\-][a-zA-Z0-9_\\.\\-]*@[a-zA-Z0-9][a-zA-Z0-9\\-]*(\\.[a-zA-Z0-9]+)+$'; },
    get UserName() { return '^[a-zA-Z0-9]{5,12}$'; },
    get Password() { return '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,12}$'; },
    get Decimal() { return '^[+-]?\\d*(?:\\.\\d{1,2})?$'; }
  };

  static getGenericErrorMessage() {
    return sessionStorage.getItem(Constants.SessionKeyCurrentLanguage) === Constants.LanguageCodeFrench
      ? Constants.GenericErrorMessageFrench
      : Constants.GenericErrorMessageEnglish;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/const.ts